import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, BooleanDecoder, EnumDecoder, field, StringDecoder } from '@simonbackx/simple-encoding';
import { PaymentMethod } from '../PaymentMethod.js';
/**
 * @deprecated
 */
export class RegisterMember extends AutoEncoder {
    constructor() {
        super(...arguments);
        /**
         * Set to true to put a member on the waiting list instead of registering it. Please note that the value of this property is validated. You cannot register a new member when waiting lists are enabled
         */
        this.waitingList = false;
    }
}
__decorate([
    field({ decoder: StringDecoder })
], RegisterMember.prototype, "memberId", void 0);
__decorate([
    field({ decoder: StringDecoder })
], RegisterMember.prototype, "groupId", void 0);
__decorate([
    field({ decoder: BooleanDecoder })
], RegisterMember.prototype, "reduced", void 0);
__decorate([
    field({ decoder: BooleanDecoder, version: 16 })
], RegisterMember.prototype, "waitingList", void 0);
/**
 * @deprecated
 */
export class RegisterMembers extends AutoEncoder {
}
__decorate([
    field({ decoder: new ArrayDecoder(RegisterMember) })
], RegisterMembers.prototype, "members", void 0);
__decorate([
    field({ decoder: new EnumDecoder(PaymentMethod) })
], RegisterMembers.prototype, "paymentMethod", void 0);
//# sourceMappingURL=RegisterMember.js.map